import { BuyCreditsHost, RemoteAgentNotice, SeatsPanel } from "@amtana/billing-client";
import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { BILLING_CATALOGS } from "./model/billing-copy.ts";
import { BILLING_ERROR_COPY } from "./model/billing-error-copy.ts";

const pricing = () => import("./ui/sections/pricing-screen.tsx");

// The billing area, one page per purpose (epic 40, D1100): Subscription, Plans, Credits, Invoices
// and Billing details here; Add-ons (the store's, with billing's lent SeatsPanel) and Usage
// (account's) sit between them in the same sidebar group. Older paths keep answering.

export const billingBrowserModule: BrowserModule = defineBrowserModule("billing")
  .withErrorCopy(BILLING_ERROR_COPY)
  .withScreens({
    pricing: {
      path: "/pricing",
      title: phrase(BILLING_CATALOGS, "titlePricing"),
      layout: "app",
      load: pricing,
    },
    subscription: {
      path: "/subscription",
      title: phrase(BILLING_CATALOGS, "titleSubscription"),
      layout: "app",
      load: () => import("./ui/sections/subscription-screen.tsx"),
    },
    // Checkouts started before the return URLs moved to /subscription still come back here.
    billing: {
      path: "/billing",
      title: phrase(BILLING_CATALOGS, "titleSubscription"),
      layout: "app",
      load: () => import("./ui/sections/subscription-screen.tsx"),
    },
    upgrade: {
      path: "/upgrade",
      title: phrase(BILLING_CATALOGS, "titlePricing"),
      layout: "app",
      load: pricing,
    },
    credits: {
      path: "/credits",
      title: phrase(BILLING_CATALOGS, "titleCredits"),
      layout: "app",
      load: () => import("./ui/sections/credits-screen.tsx"),
    },
    refill: {
      path: "/refill-credits",
      title: phrase(BILLING_CATALOGS, "titleCredits"),
      layout: "app",
      load: () => import("./ui/sections/refill-credits-screen.tsx"),
    },
    invoices: {
      path: "/invoices",
      title: phrase(BILLING_CATALOGS, "titleInvoices"),
      layout: "app",
      load: () => import("./ui/sections/invoices-screen.tsx"),
    },
    billingDetails: {
      path: "/billing-details",
      title: phrase(BILLING_CATALOGS, "titleBillingDetails"),
      layout: "app",
      load: () => import("./ui/sections/billing-details-screen.tsx"),
    },
  })
  .withLends([
    { token: SeatsPanel, load: () => import("./ui/blocks/seats-panel.tsx") },
    { token: BuyCreditsHost, load: () => import("./ui/blocks/buy-credits-host.tsx") },
    { token: RemoteAgentNotice, load: () => import("./ui/sections/remote-agent-notice.tsx") },
  ])
  .withNavigation([
    {
      id: "plan",
      group: "settings-billing",
      label: phrase(BILLING_CATALOGS, "navSubscription"),
      href: "/subscription",
      icon: "credit-card",
      order: 900,
      activeFor: ["/billing"],
    },
    {
      id: "plans",
      group: "settings-billing",
      label: phrase(BILLING_CATALOGS, "navPlans"),
      href: "/pricing",
      icon: "gem",
      order: 905,
      activeFor: ["/upgrade"],
    },
    {
      id: "credits",
      group: "settings-billing",
      label: phrase(BILLING_CATALOGS, "navCredits"),
      href: "/credits",
      icon: "zap",
      order: 910,
      activeFor: ["/refill-credits"],
    },
    {
      id: "invoices",
      group: "settings-billing",
      label: phrase(BILLING_CATALOGS, "navInvoices"),
      href: "/invoices",
      icon: "download",
      order: 940,
    },
    {
      id: "billing-details",
      group: "settings-billing",
      label: phrase(BILLING_CATALOGS, "navBillingDetails"),
      href: "/billing-details",
      icon: "building",
      order: 950,
    },
  ]);
